// extracted by mini-css-extract-plugin
export var scrollWrap = "MobileSlider-module--scrollWrap--f2541";
export var sliderControl = "MobileSlider-module--sliderControl--6a573";